/**
 * @description PC 样式的 checkbox
 * @author wayou
 */

import React from 'react';

import './MCheckbox.scss';

import { classMapSet } from '@umu/umu-util';

interface IProps {
    isChecked: boolean;
    onChange?(checked: boolean): void;
}
interface IState {
    isChecked: boolean;
}

class MCheckbox extends React.Component<IProps, IState> {
    public static defaultProps = {
        isChecked: true,
    };

    constructor(props: IProps) {
        super(props);
        this.state = {
            isChecked: props.isChecked,
        };
        this.onChange = this.onChange.bind(this);
    }

    public UNSAFE_componentWillReceiveProps(newProps: IProps) {
        if (newProps.isChecked !== this.props.isChecked) {
            this.setState({
                isChecked: newProps.isChecked,
            });
        }
    }

    public onChange(event: React.ChangeEvent<HTMLInputElement>) {
        const checked = event.target.checked;
        this.setState({
            isChecked: checked,
        });
        if (this.props.onChange) {
            this.props.onChange(checked);
        }
    }

    public render() {
        const clsNames = classMapSet({
            'm-checkbox': true,
            'checked': this.state.isChecked,
        });
        return (
            <div className={clsNames}>
                <input type="checkbox" checked={this.state.isChecked} onChange={this.onChange} />
                <i className="icon icon-checkbox"></i>
            </div>
        );
    }
}

export default MCheckbox;
